import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { getSubContractorRecords } from "./SubContractorSlice";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";

export const GetSubContractorsApi = (search) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/SubContractor/GetSubContractorsList`, search)
      .then((res) => {
        dispatch(
          getSubContractorRecords({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "SubContractor.Notification.Errorwhilefetch"
    );
  }
};

export const UpsertSubContractorsApi = (input, filter) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/SubContractor/UpsertSubContractor`, input)
      .then((res) => {
        dispatch(uploadAttachment(res?.data));
        dispatch(GetSubContractorsApi(filter));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "SubContractor.Notification.SubAdded"
        );
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          e.response?.data?.InnerException?.Message,
          ""
        );
        dispatch(hideLoader());
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "SubContractor.Notification.SubAddError"
    );
    return false;
  }
};
